<template>
<!--    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">결제약관</div>
                <div class="list-content">
&lt;!&ndash;                  <div class="filter-select-div el-div-long mb11">
                    <span class="filter-select-span mr20">언어</span>
                    <el-select v-model="langOption" class="select mr5" @change="setLanguageFilter(langOption)">
                      <el-option :value="''" :label="'전체'"></el-option>
                      <el-option :value="language.c_idx" :label="language.c_lang_ko" v-for="language in languages"
                                 :key="language.c_idx"></el-option>
                    </el-select>
                  </div>&ndash;&gt;
                  <div class="table_wrap">
                        <el-table class="list-table" header-cell-class-name="list-header" :data="languageListOption"style="width: 100%;" height="695" empty-text="데이터가 없습니다." >
                            <el-table-column
                                    class="table_no"
                                    type="index"
                                    label="No"
                                    min-width="70"
                                    class-name="num text-center">
                            </el-table-column>
                            <el-table-column label="종류" prop="c_lang_ko" class-name="text-center"></el-table-column>
                            <el-table-column
                                    label="옵션" width="85" class-name="text-center">
                                <template slot-scope="scope">
                                    <div class="row-info">
                                        <el-button
                                                @click="movePage(scope.row.c_idx)">
                                            상세
                                        </el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>-->
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    결제약관
                </div>
                <terms-component :termsType="'payment'" :cid="30"></terms-component>
                <div class="pa15 text-center btn_wrap">
                    <el-button type="save" @click="save">저장</el-button>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>

</template>

<script>
import termsUtil from "@/components/terms/termsUtil";
import {appLanguage} from "@/service/languageService";
import TermsComponent from "@/components/terms/TermsComponent";
import EventBus from "@/utils/event-bus";
export default {
        name: "TermsPayment",
        mixins: [termsUtil],
        components: {TermsComponent},
        provide() {
            return {}
        },
        props: {},
        data() {
            return {
              langOption: '',
              languageListOption: [],
                languages: appLanguage,
            }
        },
        created() {},
        mounted() {
          this.setLang()

        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
        },
        methods: {
          setLang() {
            this.languageListOption = this.languages.slice()
          },
          movePage(type) {
            this.$router.push(`/board/terms/payment/${type}`);
          },
          setLanguageFilter(idx) {
            if (idx === '') {
              this.setLang()
            } else this.languageListOption = this.languages.filter(v => v.c_idx === idx)
          },
            save() {
                EventBus.$emit('writeTerms')
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
